var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-button',{staticClass:"noborder-button download",on:{"click":function($event){return _vm.createPDF_Logbook()}}},[_c('i',{staticClass:"fas fa fa-1x fa-download mr-2"}),_vm._v("Download ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }